import { NEW_COLORS } from '../../../../../themes/colors/newColors';
import type { StyledActionCellProps } from './types';
import {
  Box,
  IconButton,
  TableCell,
  Button,
  styled as muiStyled,
} from '@mui/material';

export const StyledActionCell = muiStyled(TableCell, {
  shouldForwardProp: prop =>
    ![
      'collapsed',
      'ithaserror',
      'ithaserrormessage',
      'showEditButton',
    ].includes(prop.toString()),
})<StyledActionCellProps>(
  ({ theme, collapsed, ithaserror, ithaserrormessage, showEditButton }) => ({
    background:
      collapsed === 'true' && ithaserror === 'false'
        ? 'linear-gradient(0deg, rgba(244, 158, 0, 0.12), rgba(244, 158, 0, 0.12)), #FFFFFF'
        : ithaserror === 'true'
        ? 'linear-gradient(0deg, rgba(201, 54, 0, 0.04), rgba(201, 54, 0, 0.04)), #FFFFFF'
        : showEditButton
        ? NEW_COLORS.GRAYSCALE[50]
        : 'transparent',

    position: 'sticky',
    right: 0,
    padding: 0,

    borderBottom:
      ithaserror === 'true' && ithaserrormessage === 'false'
        ? `1px solid ${NEW_COLORS.GRAYSCALE[800]}`
        : ithaserror === 'true' && ithaserrormessage === 'true'
        ? `2px solid ${NEW_COLORS.GRAYSCALE[800]}`
        : `1px solid ${NEW_COLORS.GRAYSCALE[100]}`,

    '&:hover': {
      background:
        ithaserror === 'false' &&
        showEditButton &&
        'linear-gradient(0deg, rgba(244, 158, 0, 0.12), rgba(244, 158, 0, 0.12)), #FFFFFF',

      borderBottom:
        ithaserror === 'false' && `1px solid ${NEW_COLORS.SECONDARY[500]}`,
    },
  }),
);

export const ActionBox = muiStyled(Box)(() => ({
  '&.MuiBox-root': {
    paddingRight: '20px',
    paddingLeft: '20px',

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '10px',
  },
}));

export const CollapsedButton = muiStyled(Button)(() => ({
  '&.MuiButton-root': {
    width: '32px',
    height: '32px',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
}));

export const EditButton = muiStyled(IconButton)(() => ({
  '&.MuiIconButton-root': {
    '&:hover': {
      backgroundColor: 'transparent',
      cursor: 'pointer',
    },
  },
}));
